import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: {
        success: '#50B957',
        warning: '#F2BB50',
        error: '#F45564',
        info: '#2973CC',
    },
    primary: {
        primary100: '#eaebf5',
        primary200: '#bec2e0',
        primary300: '#929ACC',
        primary400: '#6774b6',
        primary500: '#46518a',
        primary600: '#2a3257',
        primary700: '#11152a',
    },
    secondary: {
        secondary100: '#f4ecb9',
        secondary200: '#CCC492',
        secondary300: '#a49d74',
        secondary400: '#7d7858',
        secondary500: '#59553d',
        secondary600: '#373424',
        secondary700: '#18160e',
    },
    complementary: {
        complementary100: '#c9dce8',
        complementary200: '#92B7CC',
        complementary300: '#7290a1',
        complementary400: '#546b78',
        complementary500: '#384851',
        complementary600: '#1e282e',
        complementary700: '#0c1215',
    },
    grey: {
        grey100: '#FAF7F5',
        grey200: '#EFEBE9',
        grey300: '#E7E2E0',
        grey400: '#Dfdad7',
        grey500: '#C8c0bd',
        grey600: '#9c9090',
        grey700: '#8a7d7f',
    },
    background: {
        primaryBg: '#eaebf5',
        secondaryBg: '#f4ecb9',
        greyBg: '#FAF7F5',
        whiteBg: '#ffffff',
    },
    variant: {
        primary: '#929ACC',
        secondary: '#CCC492',
        accent: '#CC92B7',
        complementary: '#92B7CC',
        white: '#ffffff',
        black: '#000000',
    }
};

const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        updateStatusColor: (state, action) => {
            const { type, color } = action.payload;
            state.status[type] = color;
        },
        updatePrimaryColor: (state, action) => {
            const { shade, color } = action.payload;
            state.primary[shade] = color;
        },
        updateSecondaryColor: (state, action) => {
            const { shade, color } = action.payload;
            state.secondary[shade] = color;
        },
        updateComplementaryColor: (state, action) => {
            const { shade, color } = action.payload;
            state.complementary[shade] = color;
        },
        updateGreyColor: (state, action) => {
            const { shade, color } = action.payload;
            state.grey[shade] = color;
        },
        updateBackgroundColor: (state, action) => {
            const { type, color } = action.payload;
            state.background[type] = color;
        },
        updateVariantColor: (state, action) => {
            const { type, color } = action.payload;
            state.variant[type] = color;
        }
    }
});

export const themeActions = themeSlice.actions;
export default themeSlice.reducer; 